<div id="error">
  <div id="errorContent" class="container-fluid">
    <div class="error-bg col-9 col-md-6">
      <div class="row mx-0 px-0 title col-11 col-md-12">
        <h1 class="my-0 py-0">Désolé, la page demandée n’est pas disponible.</h1>
      </div>
      <div class="row mx-0 px-0 subtitle col-8 col-md-12">
        <h4 class="my-0 py-0">Vous avez la possibilité de retourner à la page d'accueil du service Nous Contacter.</h4>
      </div>
      <div>
      <a routerLink="/" class="btn btn-info btn-lg" role="button" aria-pressed="true">Retourner à la page d'accueil</a>
    </div>
  </div>
</div>
</div>
